/**
 * Step Config Factory
 * Returns the ordered step list for the Individual entity type
 */

import type { EntityType, StepConfig } from '@/types/onboarding';
import { individualSteps } from './individual';

/**
 * Get the ordered step configuration for an entity type.
 * Currently only Individual flow is supported.
 */
export function getStepConfig(_entityType: EntityType | null): StepConfig[] {
  return individualSteps;
}

/**
 * All possible step IDs for route registration.
 */
export const ALL_STEP_IDS = [
  'entity-type',
  'aadhaar-kyc',
  'basic-details',
  'address',
  'pan-verification',
  'bank-verification',
  'gstin',
  'live-photo',
  'mou-preview',
  'esign',
  'success',
] as const;

export { individualSteps };
